import { userActions } from '@store/user/user.slice';

import { useMutation } from '@hook/common/use-mutation.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { useSaveMetaMutation } from '@hook/user/user.hooks';
import { UserMetaInterface } from '@interface/user/user.interface';

export const useUserMeta = () => {
  const { action } = useMutation(useSaveMetaMutation(), userActions, userActions.setMeta);

  const { meta, isLoaded, isLoading, error } = useStoreSelector((store) => store.user);

  const onSaveMeta = (current: UserMetaInterface) => action(current);

  return {
    meta,
    onSaveMeta,
    isLoaded,
    isLoading,
    error,
  };
};
